<template>
  <div class="container mt-4 border">
    <div class="d-flex align-items-center justify-content-between">
      <div style="font-size: 18px; font-weight: bold;">Plans</div>

      <!-- Toolbar -->
      <div class="d-flex align-items-center gap-2 mt-2 flex-nowrap" style="overflow:auto; white-space: nowrap;">
        <input
          v-model.trim="q"
          @keyup.enter="reload"
          type="search"
          class="form-control"
          placeholder="ค้นหาชื่อแผน (กด Enter)"
          style="max-width: 260px; min-width: 200px;"
        />
        <select v-model.number="size" class="form-select" style="width: 120px;">
          <option :value="10">10 / หน้า</option>
          <option :value="20">20 / หน้า</option>
          <option :value="50">50 / หน้า</option>
        </select>
        <button class="btn btn-outline-primary" :disabled="loading" @click="reload">
          {{ loading ? "กำลังโหลด..." : "รีเฟรช" }}
        </button>
      </div>
    </div>

    <!-- Table -->
    <table class="table table-bordered table-striped mt-2 rounded-5">
      <thead class="mt-2 border rounded">
        <tr class="bg-white">
          <th style="width:60px;">No</th>
          <th>Name</th>
          <th>Description</th>
          <th>model</th>
          <th>Latitude</th>
          <th>Longitude</th>
          <th>Status</th>
          <th style="width:180px;">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="loading">
          <td colspan="7" class="text-center text-muted py-4">กำลังโหลดข้อมูล...</td>
        </tr>
        <tr v-else-if="list_plan.length === 0">
          <td colspan="7" class="text-center text-muted py-4">ไม่พบข้อมูล</td>
        </tr>
        <tr v-else v-for="(item, index) in list_plan" :key="item.id || index">
          <td class="text-center">{{ (page - 1) * size + index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.description || '-' }}</td>
          <td>{{ item.model || '-' }}</td>
          <td>{{ item.Latitude ?? '-' }}</td>
          <td>{{ item.Longitude ?? '-' }}</td>
          <td>{{ item.status ?? '-' }}</td>
          <td class="text-center">
            <button @click="openEdit(item)" type="button" class="btn text-white py-1 px-2 rounded-4" data-bs-toggle="modal" data-bs-target="#editPlanModal"
            style="background-color: rgb(47, 144, 220); font-size: 14px;">
              <font-awesome-icon :icon="['fas', 'pen']" /> Edit
            </button>
            <button @click="deletePlan(item.id)" type="button"  class="btn btn-danger text-white py-0 ms-1 py-1 px-2 rounded-4" style="font-size: 14px;">
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Pagination -->
    <div class="d-flex justify-content-between align-items-center mt-2 mb-4">
      <div class="text-muted">ทั้งหมด: {{ total }} รายการ</div>
      <div class="btn-group">
        <button class="btn btn-outline-secondary" :disabled="page <= 1 || loading" @click="prevPage">ก่อนหน้า</button>
        <span class="btn btn-outline-secondary disabled">หน้า {{ page }}</span>
        <button class="btn btn-outline-secondary" :disabled="disableNext || loading" @click="nextPage">ถัดไป</button>
      </div>
    </div>
  </div>

  <!-- Edit Plan Modal -->
  <div class="modal fade" id="editPlanModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Plan</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label">Name</label>
            <input v-model="plan.name" type="text" class="form-control" />
          </div>
          <div class="mb-3">
            <label class="form-label">model</label>
            <input v-model="plan.model" type="text" class="form-control" />
          </div>
          <div class="mb-3">
            <label class="form-label">customer</label>
            <input v-model="plan.customer" type="text" class="form-control" />
          </div>
          <div class="mb-3">
            <label class="form-label">instrument</label>
            <input v-model="plan.instrument" type="text" class="form-control" />
          </div>
          
          <div class="mb-3">
            <label class="form-label">Description</label>
            <textarea v-model="plan.description" class="form-control" rows="3"></textarea>
          </div>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Latitude</label>
              <input v-model="plan.Latitude" type="text" class="form-control" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Longitude</label>
              <input v-model="plan.Longitude" type="text" class="form-control" />
            </div>
          </div>
        
          <div class="d-flex justify-content-between">
            <button class="btn btn-danger" @click="clearForm">Clear</button>
            <button class="btn btn-success" @click="editPlan(plan.id)">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list_plan: [],
      loading: false,
      q: "",
      page: 1,
      size: 10,
      total: 0,
      plan: { id: "", name: "", description: "", Latitude: "", Longitude: "", status: 0,model: "",customer: "",instrument: ""},
    };
  },
  computed: {
    disableNext() {
      return this.page * this.size >= this.total;
    },
  },
  methods: {
    authHeaders(json = true) {
      const token = localStorage.getItem("accessToken");
      const h = json ? { "Content-Type": "application/json" } : {};
      return token ? { ...h, Authorization: `Bearer ${token}` } : h;
    },
    async getAllPlan() {
      try {
        this.loading = true;
        const params = new URLSearchParams({
          ...(this.q ? { q: this.q } : {}),
          page: String(this.page),
          size: String(this.size),
        });
        const res = await fetch(`${process.env.VUE_APP_API_URL}/api/plan?` + params.toString(), {
          headers: this.authHeaders(false),
        });
        if (!res.ok) throw new Error("HTTP " + res.status);
        const json = await res.json();
        this.list_plan = Array.isArray(json?.data) ? json.data : [];
        this.total = json?.meta?.total ?? this.list_plan.length;
      } catch (e) {
        console.error("getAllPlan error:", e);
        this.list_plan = [];
      } finally {
        this.loading = false;
      }
    },
    reload() {
      this.page = 1;
      this.getAllPlan();
    },
    nextPage() {
      if (!this.disableNext) {
        this.page++;
        this.getAllPlan();
      }
    },
    prevPage() {
      if (this.page > 1) {
        this.page--;
        this.getAllPlan();
      }
    },
    openEdit(row) {
      this.plan = { ...row };
    },
    async editPlan(id) {
      try {
        const res = await fetch(`${process.env.VUE_APP_API_URL}/api/plan/${id}`, {
          method: "PUT",
          headers: this.authHeaders(true),
          body: JSON.stringify(this.plan),
        });
        if (!res.ok) throw new Error("HTTP " + res.status);
        await res.json();
        alert("✅ Update Plan สำเร็จ");
        this.getAllPlan();
      } catch (e) {
        console.error("editPlan error:", e);
        alert("❌ Update Plan ไม่สำเร็จ " );
      }
    },
    async deletePlan(id) {
      try {
        if (!confirm("ยืนยันลบแผนนี้?")) return;
        const res = await fetch(`${process.env.VUE_APP_API_URL}/api/plan/${id}`, {
          method: "DELETE",
          headers: this.authHeaders(true),
        });
        if (!res.ok) throw new Error("HTTP " + res.status);
        this.getAllPlan();
      } catch (e) {
        console.error("deletePlan error:", e);
      }
    },
    clearForm() {
      this.plan = { id: "", name: "", description: "", latitude: "", longitude: "", status: "0" };
    },
  },
  watch: {
    size() {
      this.reload();
    },
  },
  mounted() {
    this.getAllPlan();
  },
};
</script>

<style scoped>
.table td,
.table th {
  vertical-align: middle;
}
</style>